<template>
  <div class="samples-list_container width-responsiveness has-batch">
    <modal
      ref="batchDetails"
      template="neutral"
      ref-name="batchDetails"
      :close-button-enabled="true"
      :icon-enabled="false"
      title="Detalhes do Lote"
    >
      <spinner v-if="batchLoading" />
      <p v-else-if="batchNotFound">
        Ops! Não foi possível exibir informações do lote.
      </p>
      <div v-else>
        <batch-card
          :batch="batch"
          :is-details-mode="true"
          :eye-icon-visible="false"
          :buttons-visible="false"
        />
        <md-button
          :id="'btnOpenCardDetails'"
          class="btn btn-nonenary"
          @click="pushToBatchDetail(batch)"
        >
          <svg-loader src="/static/images/icon-open-printed-batch.svg" />VISUALIZAR LOTE
        </md-button>
      </div>
    </modal>

    <table class="apoio-datatable fixed-head">
      <colgroup>
        <col class="column-check">
        <col class="column-date">
        <col class="column-lis-number">
        <col class="column-patient">
        <col class="column-material">
        <col class="column-os-alvaro">
        <col class="column-batch">
        <col class="column-status">
        <col class="column-expander">
      </colgroup>
      <thead>
        <tr>
          <th class="column-check">
            <div class="styled-checkbox">
              <input
                id="chkSamplesSelectAll"
                v-model="selectAll"
                type="checkbox"
              >
              <label for="chkSamplesSelectAll" />
            </div>
            <md-tooltip
              md-delay="400"
              md-direction="right"
            >
              Selecionar todos
            </md-tooltip>
          </th>
          <th
            title="DATA"
            class="sort-column"
            @click.prevent="sortColumn('date')"
          >
            DATA
            <sort-column id="date" />
          </th>
          <th @click.prevent="sortColumn('os_lis')">
            <span
              v-if="!toggle.covax"
              title="OS LIS"
              class="sort-column"
            > OS LIS </span>
            <span
              v-else
              title="REQUISITION NUMBER"
              class="sort-column covax-label"
            > REQUISITION NUMBER </span>
            <md-icon
              v-if="!toggle.covax"
              class="icon-status-info"
              @click.stop.prevent
            >
              info_outline
              <md-tooltip
                md-delay="400"
                md-direction="top"
              >
                Número da Ordem de Serviço do sistema do cliente
              </md-tooltip>
            </md-icon>
            <sort-column
              id="os_lis"
              @click.prevent="sortColumn('os_lis')"
            />
          </th>
          <th
            title="PACIENTE (ID LIS)"
            class="sort-column"
            @click.prevent="sortColumn('patient_name')"
          >
            PACIENTE (ID LIS)
            <sort-column id="patient_name" />
          </th>
          <th
            class="material"
            @click.prevent="sortColumn('material_description')"
          >
            <span
              title="MATERIAL (ACOND)"
              class="sort-column"
            >MATERIAL (ACOND)</span>
            <md-icon
              class="icon-status-info"
              @click.stop.prevent
            >
              info_outline
              <md-tooltip
                md-delay="400"
                md-direction="top"
              >
                <ul>
                  <li>Material e Acondicionamento</li>
                  <li>A = Ambiente</li>
                  <li>R = Refrigerado</li>
                  <li>C = Congelado</li>
                  <li>S = Refrigerado Seco</li>
                </ul>
              </md-tooltip>
            </md-icon>
            <sort-column
              id="material_description"
              @click.prevent="sortColumn('os_lis')"
            />
          </th>
          <th
            title="OS ÁLVARO"
            class="sort-column"
            @click.prevent="sortColumn('number_alvaro_order')"
          >
            OS ÁLVARO
            <sort-column id="number_alvaro_order" />
          </th>
          <th
            title="LOTE"
            class="sort-column"
            @click.prevent="sortColumn('batch_label')"
          >
            LOTE
            <sort-column id="batch_label" />
          </th>
          <th
            v-if="samplesCurrentTab === 'aol20'"
            title="STATUS"
            class="column-narrow sort-column status"
            :class="[samplesCurrentTab !== 'aol20' ? 'disabled' : '']"
            @click.prevent="sortColumn('printed_status')"
          >
            STATUS
            <sort-column id="printed_status" />
          </th>
          <th
            v-if="samplesCurrentTab !== 'aol20'"
            class="column-narrow sort-column status"
          />
          <th />
        </tr>
      </thead>
    </table>

    <table class="apoio-datatable">
      <colgroup>
        <col class="column-check">
        <col class="column-date">
        <col class="column-lis-number">
        <col class="column-patient">
        <col class="column-material">
        <col class="column-os-alvaro">
        <col class="column-batch">
        <col class="column-status">
        <col class="column-expander">
      </colgroup>
      <template>
        <tbody
          v-for="(sample, rowIndex) in filteredArray"
          :key="rowIndex"
          :md-item="sample"
        >
          <tr
            :class="{ expanded: sample.expanded }"
            class="apoio-datatable__line"
          >
            <td class="column-check">
              <div class="styled-checkbox">
                <input
                  :id="'chk' + sampleId(sample)"
                  v-model="selected"
                  type="checkbox"
                  :value="sampleId(sample)"
                >
                <label
                  class="list-checkbox"
                  :for="'chk' + sampleId(sample)"
                />
              </div>
            </td>
            <td @click.prevent="openSampleDetails(sample)">
              <span
                :title="format(sample.date)"
                class="os-date-span"
              >{{ format(sample.date) }}</span>
            </td>
            <td @click.prevent="openSampleDetails(sample)">
              <span
                :title="sample.os_lis"
                class="os-lis-span"
              >{{ sample.os_lis }}</span>
            </td>
            <td @click.prevent="openSampleDetails(sample)">
              <span
                :title="concatNameCode(sample.patient_name, sample.patient_id_lis)"
                class="patient-name-span"
              >{{
                concatNameCode(sample.patient_name, sample.patient_id_lis)
              }}</span>
            </td>
            <td
              class="do-wrap"
              @click.prevent="openSampleDetails(sample)"
            >
              <span
                v-if="packingData(sample)"
                class="icon-wrapper"
              >
                <svg-loader
                  class="icon-rounded"
                  :src="'/static/images/icon-' + packingData(sample).state + '.svg'"
                  :class="packingData(sample).color"
                >{{ packingData(sample).name }}</svg-loader>
                <md-tooltip
                  md-delay="100"
                  md-direction="bottom"
                >{{ packingData(sample).name }}</md-tooltip>
              </span>
              <span
                v-else
                class="icon-wrapper"
              >
                <svg-loader
                  class="icon-rounded background-color-darken-gray"
                  src="/static/images/state-pending-transmission.svg"
                >Outros</svg-loader>
                <md-tooltip
                  md-delay="100"
                  md-direction="bottom"
                >Outros</md-tooltip>
              </span>
              <span
                class="text-wrapper"
                :title="concatNameCode(sample.material_description, sample.material_packaging)"
              >{{
                sample.material_description }}</span>
            </td>
            <td @click.prevent="openSampleDetails(sample)">
              <span :title="sample.number_alvaro_order">{{ sample.number_alvaro_order }}</span>
            </td>

            <td class="column-batch">
              <div
                v-if="sample.batch_label"
                @click.prevent="openBatchDetails(sample)"
              >
                <div
                  :class="{ 'batch-urgent': hasUrgent(sample.exams) }"
                  class="batch_link"
                >
                  <span>{{ sample.batch_label }}</span>
                  <svg-loader src="/static/images/icon-urgent-fast.svg" />
                  <md-tooltip>{{ changePopUp(sample.batch_label, sample.exams) }}</md-tooltip>
                </div>
                <br>
                <span
                  :title="format(sample.batch_date)"
                  class="batch-date"
                >{{ format(sample.batch_date) }}</span>
              </div>
              <div
                v-else
                @click.prevent="openSampleDetails(sample)"
              />
            </td>

            <td
              class="column-narrow"
              @click.prevent="openSampleDetails(sample)"
            >
              <div
                v-if="batchesCurrentTab === 'aol20'"
                class="icon-doc status-icon"
                :class="'printed-' + sample.printed_status"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  {{ $strings.sampleStatus[sample.printed_status] }}
                </md-tooltip>
              </div>
              <document-icon
                v-if="verifyDocs(sample)"
                :is-document-delivered="hasDocument(sample)"
              />
            </td>

            <td @click.prevent="openSampleDetails(sample)">
              <div
                class="status-icon icon-arrow-dropdown"
                :class="{ 'icon-arrow-dropdown--active': sample.expanded }"
              >
                <md-tooltip
                  md-delay="400"
                  md-direction="top"
                >
                  Detalhes
                </md-tooltip>
              </div>
            </td>
          </tr>
          <tr
            v-if="sample.expanded"
            class="row-details"
          >
            <td
              colspan="9"
              class="row-details__container"
            >
              <sample-details
                :sample="sample"
                @refresh-samples="clearAllSampleData()"
              />
            </td>
          </tr>
        </tbody>
      </template>
      <template v-if="filteredArray.length === 0 && sampleLoadingStatus === 'STATUS_END'">
        <tbody>
          <tr>
            <td colspan="9" />
          </tr>
          <tr>
            <td colspan="9">
              Sem resultados encontrados.
            </td>
          </tr>
          <tr>
            <td colspan="9" />
          </tr>
        </tbody>
      </template>
      <tfoot
        v-if="sampleLoadingStatus !== 'STATUS_END'"
        class="on-finite"
      >
        <tr>
          <td colspan="9">
            <infinite-loading
              ref="infiniteLoading"
            >
              <span slot="no-more" />
              <span slot="no-results" />
              <span slot="spinner">
                <spinner />
              </span>
            </infinite-loading>
          </td>
        </tr>
        <tr
          v-if="(totalSamples >= 1000) | hasManyItemsOnList"
          class="on-finite__message-container"
        >
          <td colspan="9">
            <loading-infinite-message
              :break-loading="breakSampleLoading"
              :update-status-count="getTotalSample"
              warning-text="Esta consulta pode conter muitos registros."
            />
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import SampleDetails from './SampleDetails'
import Spinner from '@/components/common/Spinner'
import { mapActions, mapGetters } from 'vuex'
import { formatDate } from '@/utils/date-utils'
import { concatNameAndCode } from '@/utils/string-utils'
import SortColumn from '@/components/common/SortColumn'
import { setSortation } from '@/utils/sort-columns'
import loadingInfiniteMessage from '@/components/common/LoadingInfiniteMessage'
import { SAMPLES_SELECTED, eventBus } from '@/api/eventbus'
import BatchCard from '@/components/PrintTag/Batches/Cards/BatchCard'
import batchService from '@/api/batch'
import DocumentIcon from '../../Documents/Laboratory/Flag'
import fuzzysort from 'fuzzysort'
import SvgLoader from '../../common/SvgLoader.vue'

export default {
  name: 'SamplesList',
  components: {
    'infinite-loading': InfiniteLoading,
    spinner: Spinner,
    'sample-details': SampleDetails,
    'sort-column': SortColumn,
    'loading-infinite-message': loadingInfiniteMessage,
    'batch-card': BatchCard,
    'document-icon': DocumentIcon,
    SvgLoader
  },
  props: ['filterInput'],
  data: () => ({
    selected: [],
    columnSortStatusSamples: {
      date: 'asc',
      os_lis: 'asc',
      patient_name: 'asc',
      material_description: 'asc',
      number_alvaro_order: 'asc',
      batch_label: 'asc',
      printed_status: 'asc'
    },
    batch: {},
    batchLoading: true,
    batchNotFound: false
  }),
  computed: {
    ...mapGetters([
      'samples',
      'sampleLoadingStatus',
      'totalSamples',
      'batchesCurrentTab',
      'samplesCurrentTab',
      'profile',
      'toggle'
    ]),
    filteredArray() {
      if (this.filterInput) {
        if (this.filterInput.length > 0) {
          let target = this.samples.map(sample => {
            if (sample.os_lis) {
              sample.osLis = sample.os_lis.toString()
            }
            if (sample.number_alvaro_order) {
              sample.osAlvaro = sample.number_alvaro_order.toString()
            }
            if (sample.os_order_id) {
              sample.osOrderId = sample.os_order_id.toString()
            }
            if (sample.date) {
              sample.formatedDate = this.format(sample.date)
            }
            if (sample.patient_id_lis) {
              sample.idLis = sample.patient_id_lis.toString()
              sample.nameConcat = this.concatNameCode(sample.patient_name, sample.patient_id_lis)
            }
            return sample
          })
          let result = fuzzysort.go(this.filterInput, target, {
            keys: [
              'patient_name',
              'idLis',
              'osLis',
              'nameConcat',
              'osOrderId',
              'formatedDate',
              'osAlvaro',
              'material_description'
            ],
            limit: 100,
            allowTypo: true,
            threshold: -10000
          })
          result = result.map(item => {
            item = item.obj
            return item
          })
          return result
        }
      } else {
        return this.samples
      }
    },
    selectAll: {
      get: function () {
        if (this.filteredArray.length === 0) {
          return false
        }
        return this.filteredArray ? this.selected.length === this.filteredArray.length : false
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.filteredArray.forEach(function (samples) {
            const id = samples.sample_id || samples.bar_code
            selected.push(id)
          })
        }
        this.selected = selected
      }
    },
    hasManyItemsOnList() {
      if (this.$route.query.startDate !== this.$route.query.endDate) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    sampleLoadingStatus: function (newValue) {
      switch (newValue) {
        case 'STATUS_END':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_SUCCESS':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:loaded')
          this.setWaitingSampleLoadingStatus()
          break
        case 'STATUS_FAILED':
          this.$refs.infiniteLoading.$emit('$InfiniteLoading:complete')
          break
        case 'STATUS_INITIAL':
          this.clearAllSampleData()
          this.selected = []
          if (this.$refs.infiniteLoading) {
            this.$refs.infiniteLoading.$emit('$InfiniteLoading:reset')
          }
          break
        case 'STATUS_WAITING':
          break
        default:
          break
      }
    },
    selected: function (newValue) {
      eventBus.$emit(SAMPLES_SELECTED, newValue)
    },
    batchesCurrentTab() {
      this.clearAllSampleData(this.batchesCurrentTab, true)
    }
  },
  created() {
    let self = this
    eventBus.$on(SAMPLES_SELECTED, function (value) {
      self.selected = value
    })
  },
  methods: {
    ...mapActions([
      'clearAllSampleData',
      'getServiceSampleDetails',
      'deleteSample',
      'setWaitingSampleLoadingStatus',
      'showDetailsSample',
      'clearAllSampleData',
      'sortSampleList',
      'breakSampleLoading',
      'getTotalSample'
    ]),
    pushToBatchDetail(batch) {
      let id = this.batchesCurrentTab === 'aol20' ? batch.id : batch.batchIdentifier
      this.$router.push({
        path: '/print-tag/batches/' + id,
        query: {
          startDate: this.$route.query.startDate,
          endDate: this.$route.query.endDate,
          packagingType: this.$route.query.packagingType,
          tab: this.batchesCurrentTab
        }
      })
    },
    packingData(sample) {
      let packingState
      if (sample.material_packaging) {
        packingState = this.$strings.packagingStatus.find(x => x.type === sample.material_packaging)
      } else {
        packingState = this.$strings.packagingStatus.find(x => x.id === sample.packagingId)
      }
      return packingState
    },
    sortColumn(column, columnChild) {
      this.columnSortStatusSamples[column] = setSortation(
        column,
        columnChild,
        this.columnSortStatusSamples,
        this.sortSampleList
      )
      this.pushEventToAnalytics('Ordenação da coluna ' + column)
    },
    format(v) {
      return formatDate(v)
    },
    openSampleDetails(sample) {
      if (!sample.loading) {
        this.showDetailsSample(this.samples.indexOf(sample))
        this.pushEventToAnalytics('Abrir detalhes da amostra')
      }
    },
    concatNameCode(name, code) {
      return concatNameAndCode(name, code)
    },
    openBatchDetails(sample) {
      let batchId = sample.batch_id
      this.batchLoading = true
      if (batchId) {
        this.getBatchDetails({ id: batchId, isWs: false })
      } else {
        this.getBatchDetails({ id: sample.batch_identifier, isWs: true })
      }
      this.$refs.batchDetails.open()
      this.pushEventToAnalytics('Visualizar detalhes do lote da amostra (modal) ' + this.batchesCurrentTab)
    },
    getBatchDetails(batchId) {
      batchService
        .getBatchDetails(batchId)
        .then(response => {
          this.batch = response.data
          this.batchLoading = false
          if (Object.entries(this.batch).length === 0) {
            this.batchNotFound = true
          } else {
            this.batchNotFound = false
          }
        })
        .catch(() => {
          this.batchLoading = false
          this.batchNotFound = true
        })
    },
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Impressão de Etiquetas - Amostras',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    changePopUp(title, exams) {
      if (this.hasUrgent(exams)) {
        return 'Lote urgente'
      } else {
        return title
      }
    },
    hasUrgent(exams) {
      if (!exams) {
        return false
      }
      const isUrgent = exams.findIndex(val => val.urgent === true)
      if (isUrgent != -1) {
        return true
      }
    },
    sampleId(sample) {
      if (sample.sample_id) return sample.sample_id
      return sample.bar_code
    },
    verifyDocs(document) {
      if (this.samplesCurrentTab === 'aol20') {
        return document.docRequired
      }

      if (this.samplesCurrentTab === 'aolWs') {
        if (!document.exam_order) {
          return false
        }
        const docRequired = document.exam_order.findIndex(val => val.docRequired === true)
        if (docRequired != -1) {
          return true
        }
      }
    },
    hasDocument(document) {
      if (this.samplesCurrentTab === 'aol20') {
        return document.docDelivered
      }

      if (this.samplesCurrentTab === 'aolWs') {
        return document.examDocPendingCount > 0 ? false : true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../static/stylesheets/mixins';

.samples-list_container {
  .fixed-head {
    position: relative !important;
    width: 100% !important;
  }

  .icon-arrow-dropdown {
    &--active {
      transform: rotate(180deg);
    }
  }


  .apoio-datatable__line {
    background-color: #fff;
    border-bottom: none !important;

    .do-wrap {
      display: flex;
      align-items: center;
      min-height: 53px;

      .icon-wrapper {
        float: left;
      }

      .text-wrapper {
        width: calc(100% - 29px);
      }
    }
  }

  .apoio-datatable {
    margin-top: 0px !important;

    td {
      text-transform: capitalize;
    }

    .row-details {
      &__container {
        padding: 0 15px 10px !important;
        background: #fff !important;
        margin: 0 !important;
      }
    }
  }

  .column-check {
    width: 45px;
    padding: 0 0 0 24px;
  }

  .column-material {
    width: 270px;
  }

  .column-date,
  .column-lis-number,
  .column-os-alvaro {
    width: 10%;
  }

  .column-batch {
    width: 7.5%;
  }

  .column-narrow {
    width: 70px;
    text-align: left;
    padding: 10px 0;
    text-overflow: clip;
  }

  .batch_link {
    color: #802e54;
    text-decoration: underline;
  }

  .batch-urgent {
    padding: 2px;
    height: 24px;
    width: 80px;
    color: white;
    background: #ffbf00;
    border-radius: 4px 12px 12px 4px;
    display: flex;
    justify-items: center;
    align-items: center;

    .md-icon {
      padding-right: 2px;
      margin: 0 0 0 5px;
      height: 18px;
      width: 18px;
    }
  }

  .sort-icon {
    position: absolute;
  }

  .icon-rounded {
    border-radius: 100%;
    padding: 4px;
    margin-right: 5px;
  }

  .batch-date {
    font-size: 10px;
  }

  .covax-label {
    max-width: 5.5em;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    width: inherit;
    white-space: nowrap;
    max-height: 1.3em;
  }
}

#batchDetails {
  .md-dialog {
    min-width: 310px;

    &-title {
      padding: 33px 15px 12px;
    }

    &-content {
      padding: 0 0 2em 0;

      .md-button {
        width: 80%;
        margin: auto;
        display: block;

        .md-icon {
          float: left;
          margin: 6px;
        }
      }
    }

    .standard-modal {
      &__title {
        margin-left: 1em;
      }

      &__description {
        transform: translateY(-7px);
      }
    }

    .batch-card {
      &-unprinted {
        min-height: 256px !important;
      }

      &-printed {
        min-height: auto !important;
      }
    }

    .md-card {
      margin: auto;
      width: 88%;

      .md-conditioning {
        margin-left: 1em;
      }

      .md-subhead {
        p {
          margin: 0 !important;
          letter-spacing: normal !important;

          span {
            letter-spacing: normal !important;
          }
        }
      }

      .md-card-content {
        p {
          text-align: center !important;
        }

        .md-title {
          margin-top: 0.5em !important;
        }
      }
    }
  }
}

.column-narrow.sort-column.disabled {
  pointer-events: none;

  i {
    display: none;
  }
}
</style>
